import React from 'react';
import { Skeleton } from '@mui/material';

const BillingHistoryLoader = () => {
  return (
    <>
      <tr>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{
              width: '200px',
              backgroundColor: 'whitesmoke'
            }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>{' '}
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>{' '}
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
      </tr>
      <tr>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{
              width: '200px',
              backgroundColor: 'whitesmoke'
            }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>{' '}
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>{' '}
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>{' '}
        <td>
          <Skeleton
            className="plan-c"
            variant="text"
            height={50}
            style={{ width: '100px', backgroundColor: 'whitesmoke' }}
          />
        </td>
      </tr>
    </>
  );
};

export default BillingHistoryLoader;
